import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Collapse,
  Label,
  FormGroup,
} from "reactstrap";
// import history from "../../history";
import moment from "moment";
import CartTitle from "../CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";
import CustomDatepicker from "../CustomDatepicker";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  helperFunctionForCountry,
  helperFunctionForBooleanValue,
  helperFunctionForDate,
} from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

import InputText from "../InputText";
import CustomButton from "../CustomButton";

import get from "lodash/get";

const _ = { get };

export default class PreRegisteredUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      pageSize: 10,
      page: 0,
      count: 100,
      startDate: new Date("04/01/2021"),
      endDate: new Date().setFullYear(new Date().getFullYear()),
      email: "",
    };
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      count: this.state.count,
      startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
      endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
    };
    this.props.handleFetchPreRegisteredUser(obj);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.preRegisteredUser.length !== this.props.preRegisteredUser.length
    ) {
      let state = this.state;
      state.page = Math.ceil(
        this.props.preRegisteredUser.length / this.state.count
      );
      this.setState({ ...state });
    }
  }
  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    if (state.toggleCollapse === true) {
      state.toggleCollapse = !state.toggleCollapse;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };
  handleToggleIcon = (e) => {
    let state = this.state;
    state.toggleCollapse = !state.toggleCollapse;
    if (state.toggleActive === true) {
      state.toggleActive = !state.toggleActive;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };
  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleEmailChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.preRegisteredUser.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.preRegisteredUser.length !== 0 &&
      this.props.preRegisteredUserStatus === false &&
      this.props.preRegisteredUser.length < this.props.preRegisteredUserCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        count: this.state.count,
        startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
        endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
      };
      this.props.handleFetchPreRegisteredUser(obj);
    }
  };

  handleFilterDates = (date, id) => {
    let state = this.state;
    if (id === "start") {
      state.startDate = date;
      state.endDate = "";
      this.setState({ ...state });
    }
    if (id === "end") {
      state.endDate = date;
      this.setState({ ...state });
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.startDate = "";
    state.endDate = "";
    this.setState({ ...state });
    let obj = {
      page: 0,
      count: this.state.count,
      startDate: "",
      endDate: "",
    };

    this.props.handleFetchPreRegisteredUser(obj);
    this.props.handleClearPreviousReducers();
  };

  handleExportData = (e) => {
    let state = this.state;
    let { elements } = this.props;
    let obj = {
      email: state.email,
      startDate: state.startDate,
      endDate: state.endDate,
      key: "preRegisteredUser",
    };
    if (state.email === "")
      return toast.error(
        _.get(
          elements,
          "preRegisterUserElements.emailValidationElement",
          "Email cannot be empty"
        )
      );
    return this.props.handleExportToExcel(obj);
  };

  handleSearch = () => {
    let state = this.state;
    let obj = {
      page: 0,
      count: state.count,
      startDate: moment(state.startDate).format("DD/MM/YYYY"),
      endDate: moment(state.endDate).format("DD/MM/YYYY"),
    };
    if (state.startDate !== "" && state.endDate !== "") {
      this.props.handleClearPreviousReducers();
      this.props.handleFetchPreRegisteredUser(obj);
    }
  };

  render() {
    let { elements } = this.props;
    return (
      <div className="userListing hideSearch">
        {this.props.preRegisteredUserStatus !== false ? <Loader /> : null}
        {this.props.exportToExcelStatus !== false ? <Loader /> : null}
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "preRegisterUserElements.headingElement",
                "Pre-Registrations"
              )}
              Name={_.get(
                elements,
                "preRegisterUserElements.filterButtonElement",
                "Filter"
              )}
              handleToggle={() => this.handleToggle()}
              iconClass={"hideexcel"}
              customExcelClick={() => this.handleToggleIcon()}
              textTitle={_.get(
                elements,
                "preRegisterUserElements.totalCountElement",
                "Total Count - "
              )}
              preRegisteredUserCount={this.props.preRegisteredUserCount}
            />
          </Col>

          <Col sm={12}>
            <Collapse isOpen={this.state.toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "preRegisterUserElements.startDateLabelElement",
                          "Start Date"
                        )}{" "}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "preRegisterUserElements.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "start")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMaxDate={new Date()}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "preRegisterUserElements.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "preRegisterUserElements.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "end")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={this.state.startDate}
                          // customMaxDate={new Date()}
                          customDisable={
                            this.state.startDate === "" ? true : false
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-flex mt-3">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "userListingFilterElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => this.handleSearch()}
                          customDisable={
                            this.state.startDate !== "" &&
                            this.state.endDate !== ""
                              ? false
                              : true
                          }
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "userListingFilterElements.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => this.handleClearFilter()}
                          customDisable={
                            this.state.startDate !== "" &&
                            this.state.endDate !== ""
                              ? false
                              : true
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
            <Collapse isOpen={this.state.toggleCollapse}>
              <Card className="mb-3">
                <CardBody>
                  <Row className="justify-content-start">
                    <Col lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "preRegisterUserElements.emailLabel",
                          "Email"
                        )}
                        inputType={"email"}
                        inputName={"email"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "preRegisterUserElements.emailPlaceholder",
                          "Email"
                        )}
                        customValue={this.state.email}
                        customOnChange={(e) => this.handleEmailChange(e)}
                      />
                    </Col>

                    <Col
                      lg={2}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="mt-2 pt-1 w-100">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "preRegisterUserElements.exportToExcelButtonElement",
                            "Export To Excel"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customClick={() => this.handleExportData()}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.nameElement",
                      "Name"
                    ),
                    field: "fullName",
                  },
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.ownerElement",
                      "Owner"
                    ),
                    field: "isRoyalEnfieldOwner",
                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.isRoyalEnfieldOwner
                      );
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.callingCodeElement",
                      "Calling Code"
                    ),
                    field: "callingCode",
                  },
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.phoneElement",
                      "Phone"
                    ),
                    field: "mobile",
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.emailElement",
                      "Email"
                    ),
                    field: "email",
                  },
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.createdOnElement",
                      "Created on"
                    ),
                    field: "createdOn",

                    render: (rowData) => {
                      return helperFunctionForDate(rowData.createdAt);
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.countryElement",
                      "Country"
                    ),
                    field: "country",
                    render: (rowData) => {
                      return helperFunctionForCountry(rowData.locality.country);
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsAllPromotionsElement",
                      "All Promotions"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents
                          ? rowData.consents.allpromotions
                          : "N/A"
                      );
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsCommunityActivitiesElement",
                      "Community Activities"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents
                          ? rowData.consents.communityactivities
                          : "N/A"
                      );
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsDoNotEmailElement",
                      "Do Not Email"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents ? rowData.consents.donotemail : "N/A"
                      );
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsDoNotPhoneElement",
                      "Do Not Phone"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents ? rowData.consents.donotphone : "N/A"
                      );
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsPromotionsNewsElement",
                      "Promotional News"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents
                          ? rowData.consents.promotionsnews
                          : "N/A"
                      );
                    },
                  },

                  {
                    title: _.get(
                      elements,
                      "preRegisterUserElements.consentsSurveysAndResearchElement",
                      "Survey and Research"
                    ),
                    field: "isRoyalEnfieldOwner",

                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.consents
                          ? rowData.consents.surveysandresearch
                          : "N/A"
                      );
                    },
                  },
                ]}
                data={this.props.preRegisteredUser}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "preRegisterUserElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "preRegisterUserElements.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
